// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reporte-ventas-form,
.reporte-ventas-form *,
.reporte-ventas-form *::before,
.reporte-ventas-form *::after {
    box-sizing: border-box;
}

@media (min-width: 768px) {
    .reporte-ventas-modal {
        width: min(580px, calc(100vw - 2rem));
        max-width: min(580px, calc(100vw - 2rem));
        transition: width .24s ease, max-width .24s ease;
    }

    .reporte-ventas-modal.reporte-ventas-modal--expanded {
        width: min(90vw, 1440px);
        max-width: min(90vw, 1440px);
    }

    .reporte-ventas-modal--expanded .reporte-ventas-fields {
        gap: 8px 14px;
    }

    .reporte-ventas-modal--expanded .reporte-ventas-label {
        font-size: 11px;
    }

    .reporte-ventas-modal.reporte-ventas-modal--expanded .reporte-ventas-form .form-control,
    .reporte-ventas-modal.reporte-ventas-modal--expanded .reporte-ventas-form .reporte-ventas-select__control {
        width: min(100%, 420px);
        max-width: 420px;
        min-height: 34px;
    }

    .reporte-ventas-modal.reporte-ventas-modal--expanded .reporte-ventas-form .form-control {
        height: 34px;
        padding: 5px 10px;
    }

    .reporte-ventas-modal--expanded .reporte-ventas-switch {
        min-height: 26px;
    }

    .reporte-ventas-modal--expanded .reporte-ventas-actions {
        justify-self: start;
        width: min(100%, 420px);
        padding-top: 2px;
        text-align: center;
    }
}

.reporte-ventas-form {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
}

.reporte-ventas-fields {
    display: grid;
    grid-template-columns: 132px minmax(0, 1fr);
    align-items: center;
    gap: 12px 16px;
    width: 100%;
    max-width: 100%;
}

.reporte-ventas-label {
    margin: 0;
    color: #343a40;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.reporte-ventas-fields > div {
    min-width: 0;
}

.reporte-ventas-form .form-control,
.reporte-ventas-form .form-select {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
}

.reporte-ventas-form .reporte-ventas-select__control {
    width: min(100%, 420px);
    max-width: 420px;
    box-sizing: border-box;
}

.reporte-ventas-switch {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 32px;
}

.reporte-ventas-switch .ToggleSwitch {
    margin: 0;
}

.reporte-ventas-actions {
    grid-column: 2;
    padding-top: 4px;
    text-align: center;
}

.reporte-ventas-results {
    grid-column: 1 / -1;
    width: 100%;
    min-width: 0;
    margin-top: 8px;
    border: 1px solid #dce5ed;
    border-radius: 8px;
    background: #fff;
}

.reporte-ventas-message {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 150px;
    margin: 0;
    padding: 20px;
    color: #64748b;
    font-size: 14px;
    text-align: center;
}

.reporte-ventas-message--error {
    color: #b42318;
}

.reporte-ventas-table-wrapper {
    max-height: min(48vh, 440px);
    overflow-x: auto;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #8aa5b6 #edf2f6;
}

.reporte-ventas-table-wrapper::-webkit-scrollbar {
    width: 7px;
    height: 7px;
}

.reporte-ventas-table-wrapper::-webkit-scrollbar-track {
    background: #edf2f6;
    border-radius: 8px;
}

.reporte-ventas-table-wrapper::-webkit-scrollbar-thumb {
    background: #8aa5b6;
    border-radius: 8px;
}

.reporte-ventas-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #58798d;
}

.reporte-ventas-table-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 52px;
    padding: 10px 14px;
    border-bottom: 1px solid #dce5ed;
    background: #f8fafc;
    color: #526b7d;
    font-size: 13px;
    font-weight: 600;
}

.reporte-ventas-table {
    min-width: 2800px;
    margin: 0;
    font-size: 13px;
    border-collapse: separate;
    border-spacing: 0;
}

.reporte-ventas-table > thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 11px 12px;
    border: 0;
    border-bottom: 1px solid #00537d;
    background: #006699 !important;
    color: #fff !important;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
    white-space: nowrap;
}

.reporte-ventas-table td {
    padding: 10px 12px;
    border-color: #e0e8ee;
    vertical-align: middle;
}

.reporte-ventas-table > thead > tr > th:first-child,
.reporte-ventas-table > tbody > tr > td:first-child {
    width: 130px;
    min-width: 130px;
    white-space: nowrap;
    word-break: normal;
}

.reporte-ventas-table tbody tr:nth-child(even) td {
    background: #f8fafc;
}

.reporte-ventas-table tbody tr:hover td {
    background: #e9f5fb;
}

@media (max-width: 575.98px) {
    .reporte-ventas-fields {
        grid-template-columns: 1fr;
        gap: 6px;
    }

    .reporte-ventas-label:not(:first-child) {
        margin-top: 6px;
    }

    .reporte-ventas-actions {
        grid-column: 1;
        padding-top: 10px;
    }

    .reporte-ventas-results {
        grid-column: 1;
    }

    .reporte-ventas-table-toolbar {
        align-items: stretch;
        flex-direction: column;
    }

    .reporte-ventas-form .reporte-ventas-select__control {
        width: 100%;
        max-width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/menuContratos/formReporteVentas.css"],"names":[],"mappings":"AAAA;;;;IAII,sBAAsB;AAC1B;;AAEA;IACI;QACI,qCAAqC;QACrC,yCAAyC;QACzC,gDAAgD;IACpD;;IAEA;QACI,wBAAwB;QACxB,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":[".reporte-ventas-form,\n.reporte-ventas-form *,\n.reporte-ventas-form *::before,\n.reporte-ventas-form *::after {\n    box-sizing: border-box;\n}\n\n@media (min-width: 768px) {\n    .reporte-ventas-modal {\n        width: min(580px, calc(100vw - 2rem));\n        max-width: min(580px, calc(100vw - 2rem));\n        transition: width .24s ease, max-width .24s ease;\n    }\n\n    .reporte-ventas-modal.reporte-ventas-modal--expanded {\n        width: min(90vw, 1440px);\n        max-width: min(90vw, 1440px);\n    }\n\n    .reporte-ventas-modal--expanded .reporte-ventas-fields {\n        gap: 8px 14px;\n    }\n\n    .reporte-ventas-modal--expanded .reporte-ventas-label {\n        font-size: 11px;\n    }\n\n    .reporte-ventas-modal.reporte-ventas-modal--expanded .reporte-ventas-form .form-control,\n    .reporte-ventas-modal.reporte-ventas-modal--expanded .reporte-ventas-form .reporte-ventas-select__control {\n        width: min(100%, 420px);\n        max-width: 420px;\n        min-height: 34px;\n    }\n\n    .reporte-ventas-modal.reporte-ventas-modal--expanded .reporte-ventas-form .form-control {\n        height: 34px;\n        padding: 5px 10px;\n    }\n\n    .reporte-ventas-modal--expanded .reporte-ventas-switch {\n        min-height: 26px;\n    }\n\n    .reporte-ventas-modal--expanded .reporte-ventas-actions {\n        justify-self: start;\n        width: min(100%, 420px);\n        padding-top: 2px;\n        text-align: center;\n    }\n}\n\n.reporte-ventas-form {\n    width: 100%;\n    max-width: 100%;\n    overflow: hidden;\n}\n\n.reporte-ventas-fields {\n    display: grid;\n    grid-template-columns: 132px minmax(0, 1fr);\n    align-items: center;\n    gap: 12px 16px;\n    width: 100%;\n    max-width: 100%;\n}\n\n.reporte-ventas-label {\n    margin: 0;\n    color: #343a40;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.reporte-ventas-fields > div {\n    min-width: 0;\n}\n\n.reporte-ventas-form .form-control,\n.reporte-ventas-form .form-select {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n}\n\n.reporte-ventas-form .reporte-ventas-select__control {\n    width: min(100%, 420px);\n    max-width: 420px;\n    box-sizing: border-box;\n}\n\n.reporte-ventas-switch {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 32px;\n}\n\n.reporte-ventas-switch .ToggleSwitch {\n    margin: 0;\n}\n\n.reporte-ventas-actions {\n    grid-column: 2;\n    padding-top: 4px;\n    text-align: center;\n}\n\n.reporte-ventas-results {\n    grid-column: 1 / -1;\n    width: 100%;\n    min-width: 0;\n    margin-top: 8px;\n    border: 1px solid #dce5ed;\n    border-radius: 8px;\n    background: #fff;\n}\n\n.reporte-ventas-message {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 150px;\n    margin: 0;\n    padding: 20px;\n    color: #64748b;\n    font-size: 14px;\n    text-align: center;\n}\n\n.reporte-ventas-message--error {\n    color: #b42318;\n}\n\n.reporte-ventas-table-wrapper {\n    max-height: min(48vh, 440px);\n    overflow-x: auto;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #8aa5b6 #edf2f6;\n}\n\n.reporte-ventas-table-wrapper::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n}\n\n.reporte-ventas-table-wrapper::-webkit-scrollbar-track {\n    background: #edf2f6;\n    border-radius: 8px;\n}\n\n.reporte-ventas-table-wrapper::-webkit-scrollbar-thumb {\n    background: #8aa5b6;\n    border-radius: 8px;\n}\n\n.reporte-ventas-table-wrapper::-webkit-scrollbar-thumb:hover {\n    background: #58798d;\n}\n\n.reporte-ventas-table-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    min-height: 52px;\n    padding: 10px 14px;\n    border-bottom: 1px solid #dce5ed;\n    background: #f8fafc;\n    color: #526b7d;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.reporte-ventas-table {\n    min-width: 2800px;\n    margin: 0;\n    font-size: 13px;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.reporte-ventas-table > thead > tr > th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    padding: 11px 12px;\n    border: 0;\n    border-bottom: 1px solid #00537d;\n    background: #006699 !important;\n    color: #fff !important;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: .02em;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n.reporte-ventas-table td {\n    padding: 10px 12px;\n    border-color: #e0e8ee;\n    vertical-align: middle;\n}\n\n.reporte-ventas-table > thead > tr > th:first-child,\n.reporte-ventas-table > tbody > tr > td:first-child {\n    width: 130px;\n    min-width: 130px;\n    white-space: nowrap;\n    word-break: normal;\n}\n\n.reporte-ventas-table tbody tr:nth-child(even) td {\n    background: #f8fafc;\n}\n\n.reporte-ventas-table tbody tr:hover td {\n    background: #e9f5fb;\n}\n\n@media (max-width: 575.98px) {\n    .reporte-ventas-fields {\n        grid-template-columns: 1fr;\n        gap: 6px;\n    }\n\n    .reporte-ventas-label:not(:first-child) {\n        margin-top: 6px;\n    }\n\n    .reporte-ventas-actions {\n        grid-column: 1;\n        padding-top: 10px;\n    }\n\n    .reporte-ventas-results {\n        grid-column: 1;\n    }\n\n    .reporte-ventas-table-toolbar {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .reporte-ventas-form .reporte-ventas-select__control {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
